import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  Paper,
  TableBody,
  Button,
  TextField,
  Checkbox,
} from "@mui/material";
import serverSettingsService from "./services/serverSettingsService";
import ConfirmSettingsUpdateDialog from "./ConfirmSettingsUpdateDialog";

const ServerSettings = (props) => {
  const { serverUuid } = useParams();

  const [pollingIntervalOrig, setPollingIntervalOrig] = useState();
  const [pollingInterval, setPollingInterval] = useState(600);

  const [licenseValidDateOrig, setLicenseValidDateOrig] = useState();
  const [licenseValidDate, setLicenseValidDate] = useState("");

  const [allowUpdateOrig, setAllowUpdateOrig] = useState();
  const [allowUpdate, setAllowUpdate] = useState(false);

  const [enableLinkOrig, setEnableLinkOrig] = useState(false);
  const [enableLink, setEnableLink] = useState(false);

  const [enableQuickOrig, setEnableQuickOrig] = useState(false);
  const [enableQuick, setEnableQuick] = useState(false);

  const [enableOwnCertOrig, setEnableOwnCertOrig] = useState(false);
  const [enableOwnCert, setEnableOwnCert] = useState(false);

  const [friendlyNameOrig, setFriendlyNameOrig] = useState("");
  const [friendlyName, setFriendlyName] = useState("");

  const [machineGuid, setMachineGuid] = useState("");

  const [confirmationDialogOpen, setConfirmationDialogOpen] = useState(false);
  const [updateEnabled, setUpdateEnabled] = useState(false);

  const navigate = useNavigate();

  /// sticky menu
  const [settingsObj, setSettingsObj] = useState({});
  const [showMenu, setShowMenu] = useState(false);
  const [lastScroll, setLastScroll] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScroll = window.scrollY;

      if (currentScroll > 100 && currentScroll > lastScroll) {
        setShowMenu(true); // show when scrolling down
      } else if (currentScroll < lastScroll) {
        setShowMenu(false); // hide when scrolling up
      }

      setLastScroll(currentScroll);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScroll]);
  /// sticky menu

  useEffect(() => {
    refreshSettings();
  }, [serverUuid]);

  const refreshSettings = async () => {
    const settings = await serverSettingsService.fetchServerSettings(
      serverUuid
    );
    if (!settings) {
      // navigate("/login");
      setSettingsObj({});
    }
    setSettingsObj(settings);

    setAllowUpdate(settings.allowUpdate);
    setAllowUpdateOrig(settings.allowUpdate);

    setPollingInterval(settings.pollingInterval);
    setPollingIntervalOrig(settings.pollingInterval);

    setLicenseValidDate(settings.licenseValidDate);
    setLicenseValidDateOrig(settings.licenseValidDate);

    setEnableLink(settings.enableLink);
    setEnableLinkOrig(settings.enableLink);

    setEnableQuick(settings.enableQuick);
    setEnableQuickOrig(settings.enableQuick);

    setEnableOwnCert(settings.enableOwnCert);
    setEnableOwnCertOrig(settings.enableOwnCert);

    setFriendlyName(settings.friendlyName);
    setFriendlyNameOrig(settings.friendlyName);

    setMachineGuid(settings.machineguid);
  };

  useEffect(() => {
    const settingsChanged =
      allowUpdate !== allowUpdateOrig ||
      pollingInterval !== pollingIntervalOrig ||
      licenseValidDate !== licenseValidDateOrig ||
      enableLink !== enableLinkOrig ||
      enableQuick !== enableQuickOrig ||
      enableOwnCert !== enableOwnCertOrig ||
      friendlyName !== friendlyNameOrig;

    setUpdateEnabled(settingsChanged);
  }, [
    allowUpdate,
    pollingInterval,
    licenseValidDate,
    enableLink,
    enableQuick,
    enableOwnCert,
    friendlyName,
  ]);

  const onUpdateClicked = () => {
    setConfirmationDialogOpen(true);
  };

  const onConfirmContinue = async () => {
    setConfirmationDialogOpen(false);

    if (
      await serverSettingsService.updateServerSettings(serverUuid, {
        licenseValidDate,
        pollingInterval,
        allowUpdate,
        enableLink,
        enableQuick,
        enableOwnCert,
        friendlyName,
      })
    ) {
      await refreshSettings();
    } else {
      navigate("/login");
    }
  };

  const onConfirmCancel = () => {
    setConfirmationDialogOpen(false);
  };

  return (
    <div>
      {/* sticky menu */}
      <div className={`menu-bar-container ${showMenu ? "visible" : "hidden"}`}>
        {`| Server Name: ${settingsObj.srvname} | Friendly Name: ${settingsObj.friendlyName} | Server DNS: ${settingsObj.server_dns} | IP Address: ${settingsObj.ip_address} |`}
      </div>
      {/* sticky menu */}

      <ConfirmSettingsUpdateDialog
        enableLink={enableLink}
        enableLinkOrig={enableLinkOrig}
        enableQuick={enableQuick}
        enableQuickOrig={enableQuickOrig}
        enableOwnCert={enableOwnCert}
        enableOwnCertOrig={enableOwnCertOrig}
        allowUpdateOrig={allowUpdateOrig}
        allowUpdate={allowUpdate}
        pollingInterval={pollingInterval}
        pollingIntervalOrig={pollingIntervalOrig}
        licenseValidDate={licenseValidDate}
        licenseValidDateOrig={licenseValidDateOrig}
        friendlyNameOrig={friendlyNameOrig}
        friendlyName={friendlyName}
        open={confirmationDialogOpen}
        onCancel={onConfirmCancel}
        onContinue={onConfirmContinue}
      ></ConfirmSettingsUpdateDialog>
      <Button onClick={refreshSettings}>Refresh Data</Button>
      {!machineGuid && (
        <Button href={`/api/servers/${serverUuid}/licensekey`}>
          Download License Key
        </Button>
      )}

      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }}>
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Value</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell title="friendlyName">Friendly Name</TableCell>
              <TableCell>
                <TextField
                  size="small"
                  value={friendlyName}
                  onChange={(e) => setFriendlyName(e.target.value)}
                ></TextField>
              </TableCell>
            </TableRow>
            {allowUpdate !== undefined && (
              <TableRow>
                <TableCell title="allowUpdate">
                  Allow updates from Vista
                </TableCell>
                <TableCell>
                  <Checkbox
                    checked={allowUpdate}
                    onChange={(e) => setAllowUpdate(e.target.checked)}
                  ></Checkbox>
                </TableCell>
              </TableRow>
            )}
            {enableLink !== undefined && (
              <TableRow>
                <TableCell title="enableLink">Link licenses</TableCell>
                <TableCell>
                  <Checkbox
                    checked={enableLink}
                    onChange={(e) => setEnableLink(e.target.checked)}
                  ></Checkbox>
                </TableCell>
              </TableRow>
            )}
            {enableQuick !== undefined && (
              <TableRow>
                <TableCell title="enableQuick">Quick licenses</TableCell>
                <TableCell>
                  <Checkbox
                    checked={enableQuick}
                    onChange={(e) => setEnableQuick(e.target.checked)}
                  ></Checkbox>
                </TableCell>
              </TableRow>
            )}
            {enableOwnCert !== undefined && (
              <TableRow>
                <TableCell title="enableOwnCert">
                  Use vivago certifiacates
                </TableCell>
                <TableCell>
                  <Checkbox
                    checked={enableOwnCert}
                    onChange={(e) => setEnableOwnCert(e.target.checked)}
                  ></Checkbox>
                </TableCell>
              </TableRow>
            )}
            {pollingInterval !== undefined && (
              <TableRow>
                <TableCell title="pollingInterval">
                  Vista polling interval (sec)
                </TableCell>
                <TableCell>
                  <TextField
                    size="small"
                    value={pollingInterval}
                    onChange={(e) => setPollingInterval(e.target.value)}
                  ></TextField>
                </TableCell>
              </TableRow>
            )}
            {licenseValidDate !== undefined && (
              <TableRow>
                <TableCell title="licenseValidDate">
                  License validity date
                </TableCell>
                <TableCell>
                  <TextField
                    size="small"
                    value={licenseValidDate}
                    onChange={(e) => setLicenseValidDate(e.target.value)}
                  ></TextField>
                </TableCell>
              </TableRow>
            )}
            <TableRow key={0}>
              <TableCell title="serverUuid">License Key</TableCell>
              <TableCell>
                <Typography>{serverUuid}</Typography>
              </TableCell>
            </TableRow>

            {machineGuid !== undefined && (
              <TableRow>
                <TableCell title="machineGuid">Machine ID</TableCell>
                <TableCell>
                  <Typography>{machineGuid}</Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <Button disabled={!updateEnabled} onClick={onUpdateClicked}>
        Update Settings
      </Button>
    </div>
  );
};

export default ServerSettings;
